import { useCallback, useEffect, useState, useContext } from "react";
import { useParams } from "react-router-dom";
import { FilterContext } from "../FilterContextProvider";
import useApi from "../Api/Api";

const useSales = () => {
  const [resultsLoading, setResultsLoading] = useState(false);
  const { filterData } = useContext(FilterContext);
  const api = useApi();
  const params = useParams();
  const [sales, setSales] = useState([]);
  const [pagy, setPagy] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);

  const getSales = useCallback(
    (page) => {
      setResultsLoading(true);
      let queryParams = { page };
      if (filterData.start_date && !params.eventId) {
        queryParams.start_date = filterData.start_date;
      }
      if (filterData.end_date && !params.eventId) {
        queryParams.end_date = filterData.end_date;
      }
      if (filterData.artist_id) {
        queryParams.artist_id = filterData.artist_id;
      }
      if (params.eventId) {
        queryParams.event_id = params.eventId;
      }
      if (params.productId) {
        queryParams.product_id = params.productId;
      }
      const queryString = Object.keys(queryParams)
        .map((param) => `${param}=${queryParams[param]}`)
        .join("&");
      filterData.artist_id &&
        api.get(`/sales?${queryString}`).then((r) => {
          setSales(r.data.data);
          setPagy(r.data.pagy);
          setResultsLoading(false);
        });
    },
    [
      api,
      filterData.artist_id,
      filterData.start_date,
      filterData.end_date,
      params,
    ]
  );

  useEffect(() => {
    filterData.artist_id && setPagy([]);
    setSales([]);
  }, [filterData.artist_id, params.productId]);

  useEffect(() => {
    getSales(currentPage);
  }, [getSales, currentPage, params.productId]);

  const resetPagination = () => {
    setSales([]);
    setPagy([]);
    setCurrentPage(1);
  };

  sales.forEach((sale) => {
    if (sale.date) {
      sale.date = sale.date.split("T")[0];
      const [year, month, day] = sale?.date.split("T")[0].split("-");
      sale.formattedDate = `${month}/${day}/${year}`;
    } else {
      sale.formattedDate = "No date provided";
    }
  });

  return {
    sales,
    pagy,
    currentPage,
    setCurrentPage,
    resetPagination,
    getSales,
    resultsLoading,
  };
};

export default useSales;
